import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import { Provider, useSelector } from "react-redux";
import store from "./Redux/store/store";
import {
  MidgardPool_Action,
  MidgardPool_Action_Interval,
  NGROK,
} from "./Services/mainServices";
import {
  TYPE,
  METAMASK,
  KEYSTORE,
  SET_GRAPH_DATA,
  SET_CANDLE_GRAPH_DATA,
  SET_NOTIFICATIONS_DATA,
} from "./Redux/actions/types";
import { GetKeyStore_TransactionHistory } from "./Services/mainServices";
import App from "./App";
import axios from "axios";
import { SERVER_URL_MAIN } from "./Routes/serverRoutes";

const AppIndex = () => {
  const [poolData, setPoolData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    store.dispatch(MidgardPool_Action());
    let type = localStorage.getItem(TYPE);
    if (type === KEYSTORE) {
      store.dispatch(GetKeyStore_TransactionHistory());
    }
    axios
      .get(`${SERVER_URL_MAIN}/get/graph/data`)
      .then((res) => {
        // console.log("Graph data - ", res?.data?.graph?.data);
        store.dispatch({
          type: SET_GRAPH_DATA,
          payload: {
            graphDataCombined: res?.data?.graph?.data,
          },
        });
      })
      .catch((err) => console.log("Err getting graph data - ", err));
    axios
      .get(`${NGROK}/get/candle/graph/data`)
      .then((e) =>
        // console.log("__________CANDLE_____ ", e?.data?.data?.candle)
        store.dispatch({
          type: SET_CANDLE_GRAPH_DATA,
          payload: {
            candleGraphData: e?.data?.data?.candle,
          },
        })
      )
      .catch((e) => console.log("______ERR fetching CANDLE______ ", e));

    setInterval(() => {
      store.dispatch(MidgardPool_Action_Interval());
      console.log("><<><> USING INTERVAL");
    }, 7000);
  }, []);

  return (
    <>
      <ToastContainer />
      <Provider store={store}>
        <App />
      </Provider>
    </>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <AppIndex />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
